export enum BankAccountType {
  Savings = 'savings',
  Checking = 'checking',
}
